import React, { FC, useEffect, useState } from "react";
import styles from "./AppWrapper.module.css";
import clsx from "clsx";
import { routeBlackList } from "./@types/RouteBlacklist";

const AppWrapper: FC<{ children: React.ReactNode }> = ({ children }) => {
	const blackList = routeBlackList;
	const [isBlackListed, setIsBlackListed] = useState(false);

	useEffect(() => {
		if (blackList.some((b) => location.pathname.toLowerCase().startsWith(b.toLowerCase()))) {
			setIsBlackListed(true);
		} else {
			setIsBlackListed(false);
		}
	}, [location.pathname]);

	return (
		<div className={clsx({ [styles.wrapper]: !isBlackListed })}>{children}</div>
	);
};

export default AppWrapper;
